// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_splidejs_splide-extension-video_dist_js_splide-extension-video_esm_js-no-dadfff"], function() { return __webpack_require__(9661); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
